import { useI18n } from 'vue-i18n'

import useBlProviders from '@/composables/providers/useBlProvider.js'
import FinanceCategoriesDt from '@/services/dataTransferModules/financeCategoriesDt'

export default function useFinanceCategories(params = {}) {
	const financeCategoriesDt = new FinanceCategoriesDt()

	const { t: $t } = useI18n()

	const defaults = {
		creatingFinanceCategory: {
			name: '',
		},
		fieldsToPatch: ['name'],
	}

	const {
		loadEntityFlags: flags,

		entities: financeCategories,
		getEntities: getFinanceCategories,

		entity: financeCategory,
		getEntity: getFinanceCategory,

		entityPreview: financeCategoryPreview,
		getEntityPreview: getFinanceCategoryPreview,

		entityPopup: financeCategoryPopup,
		getEntityPopup: getFinanceCategoryPopup,

		createEntity: createFinanceCategory,

		patchEntity: putFinanceCategory,
		updateEntity: updateFinanceCategory,

		deleteEntity: deleteFinanceCategory
	} = useBlProviders(
		financeCategoriesDt,
		Object.assign({
			showErrorNotificationForLoadingAllEntities: true,
			errorNotificationTextForLoadingAllEntities: $t('Finance categories loaded with an error'),

			showErrorNotificationForCreatingEntity: true,
			errorNotificationTextForCreatingEntity: $t('Error when adding finance category'),

			showErrorNotificationForLoadingOneEntity: true,

			showErrorNotificationForUpdatingEntity: true,
			errorNotificationTextForUpdatingEntity: $t('Error when editing a finance category'),

			showErrorNotificationForDeletingEntity: true,
		}, params))

	return {
		flags,
		financeCategories,
		financeCategoryPreview,
		financeCategoryPopup,
		financeCategory,
		defaults,
		getFinanceCategories,
		getFinanceCategoryPreview,
		getFinanceCategoryPopup,
		getFinanceCategory,
		createFinanceCategory,
		deleteFinanceCategory,
		updateFinanceCategory,
		putFinanceCategory,
	}
}
